import { AppState } from "../appState";

export const clearingCodesSelector = (state: AppState) =>
  state.clearingCodesMasterData;
